import { z } from "zod";

/**
 * The one place that reads build-time settings (Vite `VITE_*` env). Everything here ends up in the
 * browser bundle, so it is public by definition: never put a secret in it.
 */
const EnvSchema = z.object({
  VITE_APP_ENV: z.enum(["local", "stage", "prod"]).default("local"),
  /** Empty: same origin (local dev, where Vite proxies /v1 to the API). */
  VITE_API_BASE_URL: z.string().default(""),
  VITE_FIREBASE_API_KEY: z.string().default(""),
  VITE_FIREBASE_AUTH_DOMAIN: z.string().default(""),
  VITE_FIREBASE_PROJECT_ID: z.string().default(""),
  VITE_FIREBASE_APP_ID: z.string().default(""),
});

const env = EnvSchema.parse(import.meta.env);

export const config = {
  appEnv: env.VITE_APP_ENV,
  apiBaseUrl: env.VITE_API_BASE_URL.replace(/\/+$/, ""),
  firebase: {
    apiKey: env.VITE_FIREBASE_API_KEY,
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: env.VITE_FIREBASE_PROJECT_ID,
    appId: env.VITE_FIREBASE_APP_ID,
  },
  /** Sign-in needs the Firebase web app's public config. */
  firebaseConfigured: Boolean(env.VITE_FIREBASE_API_KEY && env.VITE_FIREBASE_APP_ID),
} as const;

export type AppConfig = typeof config;
